(() => {
  function Rotator() {
    'ngInject';

    const directive = {
      restrict: 'A',
      priority: 998,

      link(scope, element, attrs) {
        let rotation = 0,
        rotateButton = element.find(`#${attrs.rotator}`);
        const photoContainer = element.find('.photo-image-container');

        // file = element.data().$scope.file;
        // this.Media.getFileDetails(file.file_id)
        //   .then(({data}) => {
        //     console.log(data);
        //   })

        rotateButton.click(() => {
          const image = element.find('img');
          var transform = image[0].style.transform;

          if (transform.indexOf("rotate") > -1) {
            rotation = parseInt(transform.replace("rotate(", "").replace("deg)", ""));
          } else {
            rotation = 0;
          }

          rotation += 90;
          const parentWidth = element.width();
          const containerHeight = photoContainer.height();
          const containerWidth = photoContainer.width();
          const isRotatedLandscape = (rotation / 90) % 2;
          const maxHeight = (isRotatedLandscape ? containerHeight : containerWidth);
          const maxWidth = (isRotatedLandscape ? containerWidth : containerHeight);

          photoContainer.css({
            height: `${isRotatedLandscape ? maxHeight : maxWidth}px`,
            width: `${parentWidth}px`,
          });
          image.css({
            width: `${maxHeight}px`,
            transform: `rotate(${rotation}deg)`
          });
          const offsetDiff = element.offset().top - image.offset().top;
          const offsetRightDiff = photoContainer[0].getBoundingClientRect().right - image[0].getBoundingClientRect().right;

          if (offsetRightDiff > 0) {
            const offsetLeftDiff = image[0].getBoundingClientRect().left - photoContainer[0].getBoundingClientRect().left;
            const middleDelta = (offsetRightDiff + offsetLeftDiff) / 2;
            image.css('left', `${middleDelta - offsetLeftDiff}px`);
          } else {
            image.css('left', 0);
          }

          // image is below top of container
          if (offsetDiff <= 0) {
            image.css('top', '0');
          } // image is above top of container push it down
          else {
            image.css('top', `${offsetDiff}px`);
          } // try {
          //   this.Media.rotateImage(file.file_id, rotation);
          // } catch(e) {}

        });
      }

    };
    return directive;
  }

  angular.module('pims').directive('rotator', Rotator);
})();
